import UserForm from './UserForm';
import Profile from './Profile';
import ChangePassword from './ChangePassword';
import UsersList from './UsersList';
import BlockIAMRoute from '../utilities/BlockIAMRoute';

const UsersListConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/users',
      element: (
        <BlockIAMRoute>
          <UsersList />
        </BlockIAMRoute>
      ),
    },
    {
      path: '/profile',
      element: <Profile />,
    },
    {
      path: '/changePassword',
      element: <ChangePassword />,
    },
    {
      path: '/addUser',
      element: <UserForm />,
    },
    {
      path: '/editUser/:id',
      element: (
        <BlockIAMRoute>
          <UserForm />
        </BlockIAMRoute>
      ),
    },
  ],
};

export default UsersListConfig;
